import React from 'react'
import mrJournaler from '../../../../assets/home/mr-journaler_word.png'
import geminiLogo from '../../../../assets/home/aiProviders/gemini.png'
import chatgptLogo from '../../../../assets/home/aiProviders/chatgpt.png'
import claudeLogo from '../../../../assets/home/aiProviders/claude.png'
import copilotLogo from '../../../../assets/home/aiProviders/copilot.png'
import FeatureDescriptionCard from './FeatureDescriptionCard'
import clsx from 'clsx'
import styles from './index.module.css'
import RouteButton from '../../../../components/atoms/RouteButton'
import { JOURNALER_URL, TELEGRAM_URL } from '../../../../constants/links'
import { FaTelegramPlane } from 'react-icons/fa'
import { useLocation } from 'react-router-dom';

const featureCards = [
    {
        key: 1,
        icon: '⚡',
        description: 'How do I export transactions to QuickBooks?'
    },
    {
        key: 2,
        icon: '⚡',
        description: 'What was my wallet ending balance last month?'
    },
    {
        key: 3,
        icon: '⚡',
        description: 'How are staking rewards treated for tax purposes?'
    },
    {
        key: 4,
        icon: '⚡',
        description: 'Please automatically label all deposits as Transfers.'
    },
    {
        key: 5,
        icon: '⚡',
        description: 'Why are my balances not matching after import?'
    },
    {
        key: 6,
        icon: '⚡',
        description: 'What are the crypto tax reporting requirements in Dubai?'
    },
]

const aiProviders = [
    { key: 'gemini', name: 'Gemini', logo: geminiLogo },
    { key: 'chatgpt', name: 'ChatGPT', logo: chatgptLogo },
    { key: 'claude', name: 'Claude', logo: claudeLogo },
    { key: 'copilot', name: 'Copilot', logo: copilotLogo },
]
const AI_INFO_SECTION_ID = 'ai-info-section';

const AIInformation = ({ headerTitle, isHiddenLogo = false, isHiddenAEM }) => {
    const location = useLocation();

    React.useEffect(() => {
        if (location.hash === `#${AI_INFO_SECTION_ID}`) {
            const timer = setTimeout(() => {
                document.getElementById(AI_INFO_SECTION_ID)?.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'nearest',
                    block: 'center',
                });
            }, 100);
            return () => clearTimeout(timer);
        }

        window.scrollTo(0, 0);
    }, [location.pathname, location.hash]);
    return (
        <div id="ai-info-section" className='py-5' >
            <div className='container'>
                <div className={clsx('row px-2', styles.mainGroup)} >
                    <div className='col-12 col-md-5'>
                        <div className={clsx('d-flex flex-column', styles.descriptionGroup)}>
                            {!isHiddenLogo && <img src={mrJournaler} width={311} height={38} alt='mr journaler' className='img-fluid' />}
                            <div>
                                <span className={styles.featureTitle}>
                                    {headerTitle
                                        ? headerTitle
                                        : (
                                            <>
                                                AI-Powered <br />
                                                Crypto Accounting <br />
                                                Assistant
                                            </>
                                        )}
                                </span>
                            </div>

                            {isHiddenAEM && (
                                <div>
                                    <span className={styles.featureStyle}>
                                        by AEM Algorithm
                                    </span>
                                </div>
                            )}

                            <div>
                                <RouteButton href={JOURNALER_URL} variant="primary" tone="dark">
                                    Start on Journaler
                                </RouteButton>
                            </div>

                            <div>
                                <RouteButton
                                    href={TELEGRAM_URL}
                                    variant="accent"
                                    icon={<FaTelegramPlane aria-hidden />}
                                >
                                    Start on Telegram
                                </RouteButton>
                            </div>
                        </div>
                    </div>

                    <div className='col-12 col-md-7'>
                        <div className={clsx('d-flex flex-column', styles.featureGroup)}>
                            {featureCards.map((card) => (
                                <FeatureDescriptionCard key={card.key} icon={card.icon} description={card.description} />
                            ))}
                        </div>
                    </div>
                </div>

                <div className={clsx('d-flex flex-column align-items-center px-2', styles.connectGroup)}>
                    <span className={styles.featureStyle}>Connect with</span>
                    <div className={clsx('d-flex flex-wrap align-items-center justify-content-center', styles.providerLogos)}>
                        {aiProviders.map((provider) => (
                            <img
                                key={provider.key}
                                src={provider.logo}
                                alt={provider.name}
                                className={styles.providerLogo}
                            />
                        ))}
                    </div>
                    <p className={styles.connectDescription}>
                        Connect Journaler with Gemini, Chat GPT, Claude and Copilot to streamline transaction tracking, wallet balances tracking, accounting questions and tax reporting.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default AIInformation
